import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface LetContext<T> {
	angieLet: T;
	$implicit: T;
}

/**
 * Allow binding a value to view context.
 * See original code from Gist and similar library implementations.
 *
 * @see https://gist.github.com/d3lm/331373e0a5c7ff4fef61ecb8878d1eee
 * @see https://ngrx.io/guide/component/let
 * @see https://www.rx-angular.io/docs/template/api/rx-let-directive
 *
 * @example
 * ```
 * <ng-container *angieLet="myObjectFromStream$ | async as myObject">
 *    {{ myObject.propA }}
 *    {{ myObject.propB }}
 * </ng-container>
 * ```
 */
@Directive({
	selector: '[angieLet]',
	standalone: true
})
export class AngieLetDirective<T> {
	private _context: LetContext<T> = { angieLet: null, $implicit: null };

	constructor(_viewContainer: ViewContainerRef, _templateRef: TemplateRef<LetContext<T>>) {
		_viewContainer.createEmbeddedView(_templateRef, this._context);
	}

	@Input()
	set angieLet(value: T) {
		this._context.$implicit = this._context.angieLet = value;
	}
}
